module.exports = __webpack_public_path__ + "images/fontello.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/mavon-editor/dist/font/fontello.ttf
// module id = 947
// module chunks = 2